import { render, staticRenderFns } from "./MessageDetailsOverlay.vue?vue&type=template&id=545bd54e"
import script from "./MessageDetailsOverlay.vue?vue&type=script&lang=js"
export * from "./MessageDetailsOverlay.vue?vue&type=script&lang=js"
import style0 from "./MessageDetailsOverlay.vue?vue&type=style&index=0&id=545bd54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports